import React from "react";
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { ICategory } from "components/interface";
import { handleSetFilter } from "pages/home/homePageSlice";
import { useAppDispatch } from "app/hooks";
import { useNavigate } from "react-router-dom";
import { PageUrl } from "configuration/enum";

type Props = {
  handleDrawerToggle: () => void;
  navItems: Array<ICategory>;
  mobileOpen: boolean;
};

const drawerWidth = 240;
const Sidenav = (props: Props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { navItems, handleDrawerToggle, mobileOpen } = props;
  const handleItemClick = (link: string) => {
    navigate(PageUrl.HOMEPAGE);
    dispatch(handleSetFilter(link));
  };

  return (
    <Box component="nav">
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
      >
        <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
          <Typography variant="h6" sx={{ my: 2 }}>
            Newspaper
          </Typography>
          <Divider />
          <List>
            {navItems.map((item) => (
              <ListItem
                key={item.link}
                disablePadding
                onClick={() => handleItemClick(item.link)}
              >
                <ListItemButton sx={{ textAlign: "center" }}>
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default Sidenav;
